export const tailMisc = {
  tabBottom: {
    checkins: `Check-ins`,
    checkinsProg: `Upcoming`,
    requests: `Requests`,
  },
  adminNav: {
    myAccount: `My account`,
  },
  loader: {
    title: `Creating {reason}!`,
    defaultReason: `accommodation`,
    preparing: `We're setting up your {reason}, please wait…`,
    calendar: `Setting up the calendar`,
    availability: `Checking availability`,
    prices: `Setting up prices`,
    almostDone: `Almost done, finishing your {reason}…`,
  },
};
